import React, { useEffect, useState } from "react";
import DynamicViewTable from "./DynamicViewTable";
import Popup from "reactjs-popup";
import print from "print-js";
import "./CrossingInward.css";
import { mrBillingApiConfig } from "../config/apiConfig.js";
import Autosuggest from "react-autosuggest";
import {
    dataObject,
    validate,
    mrBillingTableHeader,
    mrBillingTableItems,
    groupInfo, 
    popupInfo,
    transporterFieldInfo,
} from "../config/mrBilling";
import FormColumn from "./FormColumn.js";
import "./AutoSuggest.css";
import useForm from "./useForm";
import { SERVER_URL, USE_OVERLAY } from "../config/config";
import LoadingOverlay from "react-loading-overlay";
import ReportExcel from "./ReportExcel.js";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useLocation } from "react-router-dom";

const MrBillingForm = ({ sessionObject }) => {
    const [mailStatus, setMailStatus] = useState("");
    const [updateStatus, setUpdateStatus] = useState("");
    const [isPodBilling, setIsPodBilling] = useState(false);
    const location = useLocation();

    let variablesFromSession = {
        created_from: String(sessionObject.sessionVariables.branch_id),
        created_by: String(sessionObject.sessionVariables.user_id),
        company_id: sessionObject.sessionVariables.company_id ?? "1",
        fYear: sessionObject.sessionVariables.financial_year,
    };

    const updateBiltyRate = async () => {
        myForm.setOverlay(true);

        const url = SERVER_URL + "/bilty/update_rate";
        const dataToSend = {
            date_from: new Date(myForm.pageState.update_date_from).toISOString(),
            date_to: new Date(myForm.pageState.update_date_to).toISOString(),
            consignor_id: parseInt(myForm.pageState.consignor_id),
            bill_id: parseInt(myForm.pageState.id),
            station_from: parseInt(myForm.pageState.created_from),
        };

        let resp = await fetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(dataToSend),
        })

        if (resp.ok) {
            const details = await resp.json();
            if ("flag" in details && details.flag == "1") {
                setUpdateStatus("Updation Successful!");
            }
            else {
                setUpdateStatus(details.detail);
            }
        }
        else {
            setUpdateStatus("Something went wrong, Could not update.")
        }
        myForm.setOverlay(false);
    }

    const myForm = useForm(
        "MRBILLING",
        validate,
        { ...dataObject, ...variablesFromSession },
        mrBillingApiConfig
    );

    const handlePrint = async () => {
        console.log("STUCK_TEST")
        let url = SERVER_URL + "/delivery_billing_statement/print/";

        let apiInputData = {
            ...myForm.pageState,
            fyear: myForm.pageState.fYear_get,
            companyId: myForm.pageState.company_id,
        }

        let response = await fetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify(apiInputData),
        }).then((r) => r.blob());
        console.log("response", response);
        print({ printable: URL.createObjectURL(response), type: "pdf", showModal: false });
    }

    const download_ref = React.useRef(null);

    const contentStyle = {
        maxWidth: "600px",
        width: "90%",
    };

   

    const linkBilty = async (e) => {
        if (e.target.value == "" && e.key == "Enter") {
            myForm.makeFocusOnParticularField("remarks");
            return;
        }
        if (e.key == "Enter") {
            // TODO: hit api here, changes for bilty_info
            const fYear_fetch = JSON.parse(sessionStorage.getItem("financial_year_for_fetch")).financial_year_for_fetch;

            const temp = (isPodBilling) ? "pod_billing" : "delivery_billing_party";

            let url =
                SERVER_URL +
                `/money_receipt/${temp}/?branch_id=` +
                String(myForm.pageState.created_from);


            if ("consignor_name" in myForm.refStoreObject.current) {
                myForm.refStoreObject.current.consignor_name.blur();
            }
            myForm.setOverlay(true);

            const payload = {
                date_to: myForm.pageState.input_date,
                amount: myForm.pageState.amount,
                consignor_id: myForm.pageState.consignor_id,
                id: myForm.pageState.id,
                fyear: fYear_fetch,
                companyId: myForm.pageState.company_id,
            };

            if (process.env.REACT_APP_CLIENT === "arbuda") {
                payload.date_from = myForm.pageState.input_date_from;
            }

            let response = await fetch(url, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                myForm.setPageState({
                    ...myForm.pageState,
                    ["Bilty No"]: "Invalid Bilty",
                });
                myForm.setOverlay(false);
                return;
            }
            const temp_response = await response.json();
            console.log("Temp response", temp_response);
            if (temp_response.check_fail) {
                myForm.setPageState({
                    ...myForm.pageState,
                    ["Bilty No"]: "Not possible to add this bilty",
                });
                myForm.setOverlay(false);
                return;
            }
            myForm.setOverlay(false);
            let partyName = "";
            let total_amount = 0;
            let newState = {
                mr_ids: temp_response,
            };
            let tran_freight = 0;
            let our_freight = 0;
            let to_pay = 0;
            let paid = 0;
            let pkgs = 0;
            let bilty_charge = 0;
            let extra_hamali = 0;
            let dd_charge = 0;
            let mr_total_amount = 0;
            let biltyObj = {};
            console.log("ashsshs", newState)
            for (let i = 0; i < newState.mr_ids.length; i++) {
                newState.mr_ids[i].checked = "1";
                biltyObj = newState.mr_ids[i];
                tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
                mr_total_amount += parseFloat(biltyObj.total_amount) || 0;
                our_freight += parseFloat(biltyObj.item_amount) || 0;
                bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
                dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
                extra_hamali += parseFloat(biltyObj.hamali) || 0;
                if (biltyObj.pay_type == "1") {
                    to_pay += parseFloat(biltyObj.transporter_freight) || 0;
                } else {
                    paid += parseFloat(biltyObj.transporter_freight) || 0;
                }
                pkgs += parseFloat(biltyObj.no_of_package) || 0;
            }
            //   newState.transporter_freight = String(tran_freight);
            total_amount = our_freight + bilty_charge + dd_charge + extra_hamali+mr_total_amount;
            newState.gross_amount = String(parseInt(mr_total_amount));
            newState.bilty_charge = String(bilty_charge);
            newState.door_del_charge = String(dd_charge);
            newState.extra_hamali = String(extra_hamali);
            newState.total_amount = String(parseInt(total_amount));

            //   newState.pkgs = String(pkgs);
            //   newState.to_pay = String(to_pay);
            //   newState.paid = String(paid);
            //   newState.balance = String(our_freight - to_pay);

            // TODO: set fyear? if not setting automatically
            console.log("New state", newState);
            myForm.setPageState({
                ...myForm.pageState,
                ...newState,
            });
            myForm.makeFocusOnParticularField("bill_date");
        }
    };

    const handleDelete = async () => {
        const url =
            SERVER_URL +
            "/delivery_billing_statement/?delivery_statement_id=" +
            myForm.pageState.id
            + "&fyear=" + myForm.pageState.fYear_get;
        const response = await fetch(url, { method: "DELETE" });
        if (!response.ok) {
            console.log("Not able to delete Bill");
            return;
        }
        const temp_response = await response.json();
        if (temp_response.is_deleted) {
            myForm.setPageState({ ...dataObject, ...variablesFromSession });
            myForm.setPageMode("write");
            window.location.reload();
            return;
        }
    };

    const handleCheckboxChange = (arr, item, idx) => {
        console.log("item", item);
        console.log("arrr", arr.target, arr.target.checked);
        let dummyArray = myForm.pageState.mr_ids;
        console.log("bilty ids dummy", myForm.pageState.mr_ids,dummyArray);
        if (arr.target.checked) {
            dummyArray[idx].checked = "1";
        } else {
            dummyArray[idx].checked = "0";
        }
        let newState = {
            mr_ids: dummyArray,
        };
        let total_amount = 0;
        let tran_freight = 0;
        let our_freight = 0;
        let to_pay = 0;
        let paid = 0;
        let pkgs = 0;
        let bilty_charge = 0;
        let extra_hamali = 0;
        let dd_charge = 0;
        let mr_total_amount = 0;
        let biltyObj = {};
        for (let i = 0; i < newState.mr_ids.length; i++) {
            if (newState.mr_ids[i].checked == "0") {
                continue;
            }
            biltyObj = newState.mr_ids[i];
            tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
            our_freight += parseFloat(biltyObj.item_amount) || 0;
            bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
            dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
            extra_hamali += parseFloat(biltyObj.hamali) || 0;
            mr_total_amount += parseFloat(biltyObj.total_amount) || 0;
            if (biltyObj.pay_type == "1") {
                to_pay += parseFloat(biltyObj.transporter_freight) || 0;
            } else {
                paid += parseFloat(biltyObj.transporter_freight) || 0;
            }
            pkgs += parseFloat(biltyObj.no_of_package) || 0;
        }
        //   newState.transporter_freight = String(tran_freight);
        total_amount = mr_total_amount;
        newState.gross_amount = String(parseInt(mr_total_amount));
        newState.bilty_charge = String(bilty_charge);
        newState.door_del_charge = String(dd_charge);
        newState.extra_hamali = String(extra_hamali);
        newState.total_amount = String(parseInt(total_amount));
        // myForm.setPageStateByField("mr_ids", dummyArray)
        myForm.setPageState({
            ...myForm.pageState,
            ...newState,
        });
    };

    const selectAll = () => {
        let dummyArray = myForm.pageState.mr_ids;
        for (let i = 0; i < dummyArray.length; i++) {
            dummyArray[i].checked = "1";
        }
        let newState = {
            mr_ids: dummyArray,
        };
        let total_amount = 0;
        let tran_freight = 0;
        let our_freight = 0;
        let to_pay = 0;
        let paid = 0;
        let pkgs = 0;
        let bilty_charge = 0;
        let extra_hamali = 0;
        let dd_charge = 0;
        let mr_total_amount = 0;
        let biltyObj = {};
        for (let i = 0; i < newState.mr_ids.length; i++) {
            if (newState.mr_ids[i].checked == "0") {
                continue;
            }
            biltyObj = newState.mr_ids[i];
            tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
            our_freight += parseFloat(biltyObj.item_amount) || 0;
            bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
            dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
            extra_hamali += parseFloat(biltyObj.hamali) || 0;
            mr_total_amount += parseFloat(biltyObj.total_amount) || 0;
            if (biltyObj.pay_type == "1") {
                to_pay += parseFloat(biltyObj.transporter_freight) || 0;
            } else {
                paid += parseFloat(biltyObj.transporter_freight) || 0;
            }
            pkgs += parseFloat(biltyObj.no_of_package) || 0;
        }
        //   newState.transporter_freight = String(tran_freight);
        total_amount = mr_total_amount;
        newState.gross_amount = String(parseInt(mr_total_amount));
        newState.bilty_charge = String(bilty_charge);
        newState.door_del_charge = String(dd_charge);
        newState.extra_hamali = String(extra_hamali);
        newState.total_amount = String(parseInt(total_amount));
        myForm.setPageStateByField("mr_ids", dummyArray)
        myForm.setPageState({
            ...myForm.pageState,
            ...newState,
        });
    };

    const deselectAll = () => {
        let dummyArray = myForm.pageState.mr_ids;
        for (let i = 0; i < dummyArray.length; i++) {
            dummyArray[i].checked = "0";
        }
        let newState = {
            mr_ids: dummyArray,
        };
        let total_amount = 0;
        let tran_freight = 0;
        let our_freight = 0;
        let to_pay = 0;
        let paid = 0;
        let pkgs = 0;
        let bilty_charge = 0;
        let extra_hamali = 0;
        let dd_charge = 0;
        let biltyObj = {};
        for (let i = 0; i < newState.mr_ids.length; i++) {
            if (newState.mr_ids[i].checked == "0") {
                continue;
            }
            biltyObj = newState.mr_ids[i];
            tran_freight += parseFloat(biltyObj.transporter_freight) || 0;
            our_freight += parseFloat(biltyObj.item_amount) || 0;
            bilty_charge += parseFloat(biltyObj.bilty_charge) || 0;
            dd_charge += parseFloat(biltyObj.door_del_charge) || 0;
            extra_hamali += parseFloat(biltyObj.hamali) || 0;
            if (biltyObj.pay_type == "1") {
                to_pay += parseFloat(biltyObj.transporter_freight) || 0;
            } else {
                paid += parseFloat(biltyObj.transporter_freight) || 0;
            }
            pkgs += parseFloat(biltyObj.no_of_package) || 0;
        }
        //   newState.transporter_freight = String(tran_freight);
        total_amount = our_freight;
        newState.gross_amount = String(parseInt(our_freight));
        newState.bilty_charge = String(bilty_charge);
        newState.door_del_charge = String(dd_charge);
        newState.extra_hamali = String(extra_hamali);
        newState.total_amount = String(parseInt(total_amount));
        myForm.setPageStateByField("mr_ids", dummyArray)
        myForm.setPageState({
            ...myForm.pageState,
            ...newState,
        });
    };

    const getSelectAllValue = () => {
        for (let i = 0; i < myForm.pageState.mr_ids.length; i++) {
            if (myForm.pageState.mr_ids[i].checked != "1") {
                return false;
            }
        }
        return true;
    };

    const checkVisibilityCondition = (fieldInfo) => {
        if (fieldInfo.name == "edit_button" && myForm.pageMode == "edit") {
            return true;
        } else if (fieldInfo.name == "total_amount") {
            return false;
        } else if (fieldInfo.name == "delete_button") {
            return false;
        } else if (
            fieldInfo.name == "cheque_no" &&
            myForm.pageState.payment_type == "1"
        ) {
            return false;
        } else {
            return true;
        }
    };

    const checkDisabledCondition = (fieldInfo) => {
        if (fieldInfo.name == "consignor_gst") {
            return "disabled";
        } else if (fieldInfo.name == "extra_hamali") {
            return "disabled";
        } else if (fieldInfo.name == "door_del_charge") {
            return "disabled";
        } else if (fieldInfo.name == "extra_percentage_amount") {
            return "disabled";
        } else if (fieldInfo.name == "bilty_charge") {
            return "disabled";
        } else if (fieldInfo.name == "gross_amount") {
            return "disabled";
        } else if (fieldInfo.name == "x") {
            return "disabled";
        } else if (fieldInfo.name == "total_amount") {
            return "disabled";
        } else if (myForm.pageMode == "view") {
            return "disabled";
        } else if (myForm.pageMode == "edit" && fieldInfo.name == "party_name") {
            return "disabled";
        } else if (myForm.pageMode == "edit" && fieldInfo.name == "input_date") {
            // return "disabled";
        } else {
            return "";
        }
    };

    const getAdditionalInfoForSuggestionFetch = (fieldInfoObject) => {
        // if (fieldInfoObject.name == "vehicle_no"){
        //   return {"limit": "10"};
        // }
        if (fieldInfoObject.name == "consignor_name") {
            additionalInfoObject.is_account_related = "1";
            // additionalInfoObject.pay_type = myForm.pageState.pay_type;
            return additionalInfoObject;
          }
        return null;
    };

    const deleteEntryFromTableCallback = (infoObject) => {
        console.log("Info objecyt", infoObject);
        let biltyObj = myForm.pageState.mr_ids[infoObject.idx];
        console.log("Bilty objecy", biltyObj);
        let newState = {};
        let tran_freight = parseFloat(myForm.pageState.transporter_freight) || 0;
        let our_freight = parseFloat(myForm.pageState.our_freight) || 0;
        let to_pay = parseFloat(myForm.pageState.to_pay) || 0;
        let paid = parseFloat(myForm.pageState.paid) || 0;
        let pkgs = parseFloat(myForm.pageState.pkgs) || 0;

        tran_freight -= parseFloat(biltyObj.transporter_freight) || 0;
        our_freight -= parseFloat(biltyObj.total_amount) || 0;
        if (biltyObj.pay_type == "1") {
            to_pay -= parseFloat(biltyObj.transporter_freight) || 0;
        } else {
            paid -= parseFloat(biltyObj.transporter_freight) || 0;
        }
        pkgs -= parseFloat(biltyObj.no_of_package) || 0;

        newState.transporter_freight = String(tran_freight);
        newState.our_freight = String(our_freight);
        newState.pkgs = String(pkgs);
        newState.to_pay = String(to_pay);
        newState.paid = String(paid);
        newState.balance = String(our_freight - to_pay);
        newState.mr_ids = infoObject.rows;

        console.log("New state", newState);
        myForm.setPageState({
            ...myForm.pageState,
            ...newState,
        });
    };

    const handleSendEmail = async () => {

        let ccEmails = myForm.pageState.cc_emails;
        ccEmails = ccEmails.split("\n").join(",");
        // console.log(ccEmails);

        myForm.setOverlay(true);

        const mailBody = myForm.pageState.body_start + "|" + myForm.pageState.body_end;

        const dataToSend = {
            tbb_statement_id: myForm.pageState.bill_no,
            branch_id: sessionObject.sessionVariables.branch_id,
            receiver_mail: myForm.pageState.email,
            subject: myForm.pageState.subject,
            cc: ccEmails,
            user_id: sessionObject.sessionVariables.user_id,
            body: mailBody,
            fyear: myForm.pageState.fYear_get,
            companyId: myForm.pageState.company_id,
        }

        const url = SERVER_URL + "/delivery_billing_statement/send_bill_mail";

        const resp = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToSend),
        })

        myForm.setOverlay(false);

        if (resp.ok) {
            const data = await resp.json();
            console.log({ data });
            setMailStatus(data.message);
        }
        else {
            setMailStatus("Something went wrong while sending an Email ):")
        }

    }

    let ccEmailFieldInfo = {
        // display
        label: "CC",

        // styling
        className: "form-row",
        labelClassName: "form-label",
        inputClassName: "form-input",

        // dataobject name
        name: "cc_email",

        // type
        type: "text",
        placeHolder: "",

        // when selected some suggestion
        // apiConfigKey: "getConsigneeSuggestions",

        // suggesion api
        url: SERVER_URL + "/mail/",

        // from resp of suggestion api, which field to show
        suggestionKeyword: "email",

        // along with suggesions, which field to show
        suggestionKeywordExtra: "company_id",

        // typed text in api, based on which results come
        suggestionKeywordForFetchApiArgs: "email",

        // when some suggestion is chosen, by which field that suggestion to fetch
        // suggestionChooseQueryKeyword: "id",

        /**
         * If api call not required,
         * parse suggestion schema here only and update the page state.
         */
        suggestionSchema: {
            email: "cc_email"
        },

        // apiCallRequiredOnGetValue: true,
        toValidate: true,
        // regExpValidation: "[a-zA-z]",
        // keyboardNavigationMap: {
        //     conditionalNav: true,
        //     conditionalNavFunct: (pageState) => {
        //         if (pageState.voucher_type == "cp") {
        //             return "amount";
        //         }
        //         else if (pageState.voucher_type == "bp") {
        //             return "id";
        //         }
        //         else if (pageState.voucher_type == "cr") {
        //             return "amount";
        //         }
        //         else if (pageState.voucher_type == "jv") {
        //             return "amount";
        //         }
        //         else if (pageState.voucher_type == "br") {
        //             return "amount";
        //         }
        //         else {
        //             return "consignee_name";
        //         }
        //     },
        // },
        // idClearanceNeeded: "consignee_id",
        // inputDataNeededInSuggestions: false,
        // inputDataFilter: {
        //     pay_type: "same",
        // },
    };

    return (
        <div className="mr-form-container">
            {USE_OVERLAY && (
                <LoadingOverlay
                    active={myForm.overlay}
                    spinner
                    text="Loading your content..."
                    styles={{
                        wrapper: {
                            // width: '400px',
                            // height: '400px',
                            overflow: true ? "hidden" : "scroll",
                        },
                    }}
                ></LoadingOverlay>
            )}
            <div>
                <Popup
                    // trigger={<button className="button"> Open Modal </button>}
                    open={myForm.pageMode == "submitted" || myForm.pageMode == "error"}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => (
                        <div className="pop-up-container">
                            <div className="pop-up-header">
                                {" "}
                                {myForm.pageMode == "submitted" ? (
                                    <div>{popupInfo.success_header}</div>
                                ) : (
                                    <div>{popupInfo.error_header}</div>
                                )}
                                <div>
                                    <a className="pop-up-close btn" onClick={close}>
                                        &times;
                                    </a>
                                </div>
                            </div>
                            {myForm.pageMode == "submitted" ? (
                                <div className="pop-up-content">
                                    {popupInfo.success_title}
                                    <br />
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <div className="pop-up-field-label">
                                                {popupInfo.field_label_success}
                                            </div>
                                            <div className="pop-up-field-value">
                                                {myForm.pageState[popupInfo.field_name_success]}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="pop-up-content">
                                    {popupInfo.error_title}
                                    <br />
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <div className="pop-up-field-label">
                                                {popupInfo.field_label_error}
                                            </div>
                                            <div className="pop-up-field-value">
                                                {myForm.popupError}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="pop-up-actions">
                                <button
                                    className="pop-up-button"
                                    onClick={() => {
                                        if (myForm.pageMode == "submitted") {
                                            myForm.setPageState({
                                                ...dataObject,
                                                ...variablesFromSession,
                                            });
                                            myForm.setPageMode("write");
                                            window.location.reload();
                                            close();
                                        } else {
                                            myForm.setPageMode("write");
                                            close();
                                        }
                                    }}
                                >
                                    Okay
                                </button>
                            </div>
                        </div>
                    )}
                </Popup>
            </div>
            <div>
                <Popup
                    open={updateStatus != ""}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => {
                        return (
                            <div className="pop-up-container">
                                <div className="pop-up-header">
                                    Status of Update
                                    <div>
                                        <a className="pop-up-close btn" onClick={() => {
                                            setUpdateStatus("");
                                            close();
                                        }}>
                                            &times;
                                        </a>
                                    </div>
                                </div>
                                <div className="popup-content">
                                    <div className="pop-up-fields">
                                        <div className="pop-up-field">
                                            <label className="">Message : </label>
                                            <div className="">
                                                {updateStatus}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pop-up-actions">
                                    <button
                                        className="pop-up-button"
                                        onClick={() => {
                                            setUpdateStatus("");
                                            close();
                                        }}
                                    >
                                        Okay
                                    </button>
                                </div>
                            </div>
                        );
                    }}
                </Popup>
            </div>
            <div>
                <Popup
                    open={myForm.deletePopup}
                    modal
                    contentStyle={contentStyle}
                    closeOnDocumentClick={false}
                >
                    {(close) => (
                        <div className="pop-up-container">
                            <div className="pop-up-header">Are you sure want to delete?</div>
                            <div className="pop-up-actions">
                                <button
                                    className="pop-up-button"
                                    onClick={() => {
                                        handleDelete();
                                        myForm.setDeletePopup(false);
                                        close();
                                    }}
                                >
                                    Yes
                                </button>
                                <button
                                    className="pop-up-button"
                                    onClick={() => {
                                        myForm.setDeletePopup(false);
                                        close();
                                    }}
                                >
                                    No
                                </button>
                            </div>
                        </div>
                    )}
                </Popup>
            </div>

            <div className="form-header">Delivery Billing</div>
            <div className="form">
                <div className="form-title">
                    <div className="form-row">
                        <label className="form-label">Delivery Billing No:</label>
                        <input
                            className="form-input"
                            type="text"
                            name="bill_no"
                            placeholder=""
                            value={myForm.pageState.bill_no}
                            onChange={myForm.handleChange}
                            onBlur={() => { }}
                            onKeyPress={(a) =>
                                myForm.getPageOnKeyEnter(a, myForm.pageState.bill_no)
                            }
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "bill_no")}
                            disabled={myForm.pageMode == "view" ? "disabled" : ""}
                        />
                        {myForm.internalValidationErrors["bill_no"] && (
                            <p>{myForm.internalValidationErrors["bill_no"]}</p>
                        )}
                        {myForm.pageMode == "view" && (
                            <>
                                {checkVisibilityCondition({ name: "edit_button" }) && (
                                    <button
                                        onClick={() => {
                                            myForm.setPageMode("edit");
                                        }}
                                    >
                                        Edit
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                    <div className="form-row">
                        <label className="form-label">{"Amount >="}</label>
                        <input
                            className="form-input"
                            type="text"
                            name="amount"
                            placeholder=""
                            value={myForm.pageState.amount}
                            onChange={myForm.handleChange}
                            onBlur={() => { }}
                            onKeyPress={(a) => {
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("input_date");
                                }
                            }}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "amount")}
                            disabled={myForm.pageMode == "view" ? "disabled" : ""}
                        />
                    </div>
                    <div className="form-row-m">
                        {["arbuda"].includes(process.env.REACT_APP_CLIENT) && (
                            <div className="form-row-m">
                                <label className="form-label">
                                Delivery Date From:
                                </label>
                                <input
                                    className="form-input-mr-statement-date"
                                    type="date"
                                    name="input_date_from"
                                    placeholder=""
                                    value={myForm.pageState.input_date_from}
                                    onChange={myForm.handleChange}
                                    ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date_from")}
                                    disabled={checkDisabledCondition({ name: "input_date_from" })}
                                    onKeyPress={(a) => {
                                        console.log("Here");
                                        if (a.key == "Enter") {
                                            myForm.makeFocusOnParticularField("consignor_name");
                                        }
                                    }}
                                />
                            </div>
                        )}
                        <label className="form-label">Delivery Date To:</label>
                        <input
                            className="form-input-mr-statement-date"
                            type="date"
                            name="input_date"
                            placeholder=""
                            value={myForm.pageState.input_date}
                            onChange={myForm.handleChange}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "input_date")}
                            disabled={checkDisabledCondition({ name: "input_date" })}
                            onKeyPress={(a) => {
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("consignor_name");
                                }
                            }}
                        />
                    </div>

                    <div className="form-row">
                        <label className="form-label">Account Name</label>
                        {myForm.pageMode == "edit"
                            ? <input
                                type="text"
                                name="consignor_name"
                                value={myForm.pageState.consignor_name}
                                onChange={myForm.handleChange}
                                className="form-input"
                                onKeyPress={linkBilty}
                            />
                            :
                            <Autosuggest
                                id={transporterFieldInfo["name"]}
                                suggestions={myForm.suggestions}
                                onSuggestionsFetchRequested={(a) =>
                                    myForm.onSuggestionsFetchRequested(a, (b) =>
                                        myForm.suggestionFetchApi(transporterFieldInfo, b)
                                    )
                                }
                                onSuggestionsClearRequested={() =>
                                    myForm.onSuggestionsClearRequested(transporterFieldInfo)
                                }
                                getSuggestionValue={(suggestion) =>
                                    suggestion[transporterFieldInfo.suggestionKeyword]
                                }
                                onSuggestionSelected={(a, b) =>
                                    myForm.getSuggestionValue(
                                        b.suggestion,
                                        transporterFieldInfo,
                                        myForm.performSuggestions,
                                        myForm.updatePageStateForGetSuggestion
                                    )
                                }
                                renderSuggestion={(a) =>
                                    myForm.renderSuggestion(a, transporterFieldInfo)
                                }
                                highlightFirstSuggestion={true}
                                ref={(a) => myForm.storeInputReference(a, false)}
                                inputProps={{
                                    //placeholder: info["name"],
                                    value: String(myForm.pageState[transporterFieldInfo["name"]]),
                                    onChange: (a, b) => {
                                        myForm.onChangeAutoSuggest(a, b, transporterFieldInfo);
                                    },
                                    onBlur: () => {
                                        transporterFieldInfo["toValidate"]
                                            ? myForm.onblurValidator(transporterFieldInfo)
                                            : {};
                                    },
                                    onKeyPress: linkBilty,
                                    disabled: checkDisabledCondition(transporterFieldInfo),
                                }}
                            />
                        }

                    </div>
                    <div>
                        <label className="form-label">Bill Date:</label>
                        <input
                            className="form-input-mr-statement-date"
                            type="date"
                            name="bill_date"
                            placeholder=""
                            value={myForm.pageState.bill_date}
                            onChange={myForm.handleChange}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "bill_date")}
                            disabled={checkDisabledCondition({ name: "bill_date" })}
                            onKeyPress={(a) => {
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("remarks");
                                }
                            }}
                        />
                    </div>
                    <div className="form-row">
                        <label className="form-last_bilty">Last Delivery Bill:</label>
                        <label className="form-consignor_bill">
                            {myForm.pageState.last_delivery_bill_no}
                        </label>
                    </div>
                </div>
                <div className="form-title-b">
                    <div className="form-row">
                        <label className="form-label">Remarks</label>
                        <input
                            className="form-input-w"
                            type="text"
                            name="remarks"
                            placeholder=""
                            value={myForm.pageState.remarks}
                            onChange={myForm.handleChange}
                            onBlur={() => { }}
                            onKeyPress={(a) => {
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("description1");
                                }
                            }}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "remarks")}
                            disabled={myForm.pageMode == "view" ? "disabled" : ""}
                        />
                    </div>

                </div>

                <div className="table-container">
                    <DynamicViewTable
                        checkBox={1}
                        tableHeader={mrBillingTableHeader}
                        tableItems={mrBillingTableItems}
                        tableValues={myForm.pageState["mr_ids"]}
                        setPageStateByField={myForm.setPageStateByField}
                        pageStateArray={myForm.pageState["mr_ids"]}
                        deleteEntryFromTableCallback={deleteEntryFromTableCallback}
                        handleCheckboxChange={handleCheckboxChange}
                        fieldMapping="mr_ids"
                        getSelectAllValue={getSelectAllValue}
                        selectAll={selectAll}
                        deselectAll={deselectAll}
                    />
                </div>
                <div className="form-input-c">
                    <div className="form-field-left">
                        <div>
                            Amt{" "}
                            <input
                                size="10"
                                name="gross_amount"
                                placeholder=""
                                value={myForm.pageState.gross_amount}
                                onChange={myForm.handleChange}
                                disabled={checkDisabledCondition({ name: "gross_amount" })}
                                onBlur={() => { }}
                                onKeyPress={(a) => {
                                    console.log("Here");
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("door_del_charge");
                                    }
                                }}
                                ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "gross_amount")
                                }
                            ></input>
                        </div>
                        <div>
                            <p />
                        </div>

                        <table border="1px">
                            <tr>
                                <th className="bill-input-small"> No.</th>
                                <th className="bill-input-small">Description</th>
                                <th className="bill-input-small">Amt</th>
                            </tr>
                            <tr>
                                <td className="bill-input-small">1</td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-large"
                                        name="description1"
                                        placeholder=""
                                        value={myForm.pageState.description1}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "description1" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("amt1");
                                            }
                                        }}
                                        ref={(a) =>
                                            myForm.storeInputReferenceForSelect(a, "description1")
                                        }
                                    ></input>
                                </td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-small"
                                        name="amt1"
                                        placeholder=""
                                        value={myForm.pageState.amt1}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "amt1" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("description2");
                                            }
                                        }}
                                        ref={(a) => myForm.storeInputReferenceForSelect(a, "amt1")}
                                    ></input>
                                </td>
                            </tr>
                            <tr>
                                <td className="bill-input-small">2</td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-large"
                                        name="description2"
                                        placeholder=""
                                        value={myForm.pageState.description2}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "description2" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("amt2");
                                            }
                                        }}
                                        ref={(a) =>
                                            myForm.storeInputReferenceForSelect(a, "description2")
                                        }
                                    ></input>
                                </td>
                                <td className="bill-input-small">
                                    <input
                                        className="bill-input-small"
                                        name="amt2"
                                        placeholder=""
                                        value={myForm.pageState.amt2}
                                        onChange={myForm.handleChange}
                                        disabled={checkDisabledCondition({ name: "amt2" })}
                                        onBlur={() => { }}
                                        onKeyPress={(a) => {
                                            console.log("Here");
                                            if (a.key == "Enter") {
                                                myForm.makeFocusOnParticularField("extra_percentage");
                                            }
                                        }}
                                        ref={(a) => myForm.storeInputReferenceForSelect(a, "amt2")}
                                    ></input>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="form-field-left">
                        <div className="bill-margin">
                            Extra(%) &nbsp; &nbsp; &nbsp; &nbsp;
                            <input
                                size="3"
                                name="extra_percentage"
                                placeholder=""
                                value={myForm.pageState.extra_percentage}
                                onChange={myForm.handleChange}
                                // disabled={checkDisabledCondition({name:"amt1"})}
                                onBlur={() => { }}
                                onKeyPress={(a) => {
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("add");
                                    }
                                }}
                                ref={(a) =>
                                    myForm.storeInputReferenceForSelect(a, "extra_percentage")
                                }
                            />
                            <input
                                size="10"
                                name="extra_percentage_amount"
                                placeholder=""
                                value={myForm.pageState.extra_percentage_amount}
                                onChange={myForm.handleChange}
                                disabled={checkDisabledCondition({
                                    name: "extra_percentage_amount",
                                })}
                                onBlur={() => { }}
                                onKeyPress={(a) => {
                                    if (a.key == "Enter") {
                                        myForm.makeFocusOnParticularField("amount");
                                    }
                                }}
                                ref={(a) =>
                                    myForm.storeInputReferenceForSelect(
                                        a,
                                        "extra_percentage_amount"
                                    )
                                }
                            ></input>
                        </div>
                        <div>
                            <p />
                        </div>
                    </div>
                    <div className="form-field-left">
                        <FormColumn
                            groupInfo={groupInfo}
                            groupName="group-1"
                            checkDisabledCondition={checkDisabledCondition}
                            checkVisibilityCondition={checkVisibilityCondition}
                            myFormObj={myForm}
                            getAdditionalInfoForSuggestionFetch={
                                getAdditionalInfoForSuggestionFetch
                            }
                        />
                    </div>
                </div>

                {myForm.pageMode == "edit" && <div className="form-title-b">
                    <div className="form-row-m" style={{ paddingTop: "10px" }}>
                        <label className="form-label">Date From:</label>
                        <input
                            className="form-input-mr-statement-date"
                            type="date"
                            name="update_date_from"
                            placeholder=""
                            value={myForm.pageState.update_date_from}
                            onChange={myForm.handleChange}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "update_date_from")}
                            disabled={checkDisabledCondition({ name: "update_date_from" })}
                            onKeyPress={(a) => {
                                console.log("Here");
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("update_date_to");
                                }
                            }}
                        />
                    </div>
                    <div className="form-row-m" style={{ paddingTop: "10px" }}>
                        <label className="form-label">Date To:</label>
                        <input
                            className="form-input-mr-statement-date"
                            type="date"
                            name="update_date_to"
                            placeholder=""
                            value={myForm.pageState.update_date_to}
                            onChange={myForm.handleChange}
                            ref={(a) => myForm.storeInputReferenceForSelect(a, "update_date_to")}
                            disabled={checkDisabledCondition({ name: "update_date_to" })}
                            onKeyPress={(a) => {
                                console.log("Here");
                                if (a.key == "Enter") {
                                    myForm.makeFocusOnParticularField("update_button");
                                }
                            }}
                        />
                    </div>
                    <button
                        onClick={updateBiltyRate}
                        type="button"
                        style={{ marginTop: "1px" }}
                        // className="btn btn-primary"
                        ref={(a) => myForm.storeInputReferenceForSelect(a, "update_button")}
                    >
                        Update
                    </button>

                </div>}

                <div className="form-footer">
                    <button style={{ display: "none" }}>
                        <ReactHTMLTableToExcel
                            id="test-table-xls-button"
                            className="download-table-xls-button"
                            table="bilty_report_excel"
                            filename="tablexls"
                            sheet="tablexls"
                            buttonText="Download as XLS"
                            ref={(a) => (download_ref.current = a)}
                        />
                    </button>
                    <button
                        className="download-table-xls-button"
                        onClick={async () => {
                            download_ref.current.handleDownload();
                        }}
                    >
                        Download as XLS
                    </button>
                    {ReportExcel.excel_mr_bill(myForm.pageState)}

                    {checkVisibilityCondition({ name: "print_button" }) && (
                        <button
                            onClick={(e) => {
                                if (myForm.pageState.edit_bill == "0") {
                                    handlePrint()
                                    return;
                                }
                                myForm.setServerPrintNeeded(true);
                                myForm.handleSubmit(e);
                            }}
                            type="button"
                            className="btn btn-primary"
                            ref={(a) =>
                                myForm.storeInputReferenceForSelect(a, "print_button")
                            }
                        >
                            Print
                        </button>
                    )}
                    <button
                        onClick={myForm.handleSubmit}
                        type="button"
                        className="btn btn-primary"
                        ref={(a) => myForm.storeInputReferenceForSelect(a, "save_button")}
                    >
                        Save
                    </button>
                    <button onClick={() => myForm.setDeletePopup(true)} className="btn btn-primary">Delete</button>
                    <button
                        onClick={() => {
                            myForm.setPageState({
                                ...dataObject,
                                ...variablesFromSession,
                            });
                            window.location.reload();
                            myForm.setPageMode("write");
                        }}
                        className="btn btn-primary"
                    >
                        New
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MrBillingForm;

/*

consignor name for edit to see


*/